import React from 'react';
import { Icon } from '~/utils';

const style = {
  height    : '90%',
  width     : '90%',
};
export function Loading( props ) {
  return <Icon icon="fas:sync" spin style={style} />;
}
